import { Suspense, useContext, useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { GroupContext } from "../../../../../contexts";
import GroupProfile from "./groupProfile/GroupProfile";
import { BBILogo, IntercityDarkLogo, IntercityLightLogo } from "../../../../../assets";
import { GroupDetails } from "../../../../../@types/components/assignGroupsProps.types";

import GroupWorkIcon from "@material-ui/icons/GroupWork";
import GroupIcon from "@material-ui/icons/Group";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";

import "./groupInformation.css";
import { GROUP_NUMBER } from "../../../../../constants/groups";

const GroupInformation = () => {
	const [groupBasicDetails, setGroupBasicDetails] = useState<GroupDetails>();
	const [coverageDetails, setCoverageDetails] = useState<GroupDetails>();
	const [locationBasicDetails, setLocationBasicDetails] = useState<GroupDetails>();
	const { groupInformation, locationInformation } = useContext(GroupContext);

	useEffect(() => {
		if (groupInformation || locationInformation) {
			if (groupInformation) {
				setGroupBasicDetails(
					Object.assign(
						{},
						{
							Name: groupInformation && groupInformation.name,
							"Tax ID": groupInformation && groupInformation.TAX_ID,
							"Address Line 1": groupInformation && groupInformation.address_1,
							"Address Line 2": groupInformation && groupInformation.address_2,
							City: groupInformation && groupInformation.city,
							State: groupInformation && groupInformation.state,
							Zip: groupInformation && groupInformation.ZIP,
							Fax: groupInformation && groupInformation.fax
						}
					)
				);
				setCoverageDetails(
					Object.assign(
						{},
						{
							"Medical Coverage":
								groupInformation && groupInformation.medical_coverage === "T" ? "True" : "N/A",
							"Vision Coverage":
								groupInformation && groupInformation.vision_coverage === "T" ? "True" : "N/A",
							"Dental Coverage":
								groupInformation && groupInformation.dental_coverage === "T" ? "True" : "N/A",
							"Drug Coverage":
								groupInformation && groupInformation.drug_coverage === "T" ? "True" : "N/A",
							"Miscellenous Coverage":
								groupInformation && groupInformation.miscellaneous_coverage === "T" ? "True" : "N/A",
							"LTD Coverage": groupInformation && groupInformation.LTD_coverage === "T" ? "True" : "N/A",
							"STD Coverage": groupInformation && groupInformation.STD_coverage === "T" ? "True" : "N/A",
							"Life Coverage": groupInformation && groupInformation.life_coverage === "T" ? "True" : "N/A"
						}
					)
				);
			} else if (locationInformation) {
				setLocationBasicDetails(
					Object.assign(
						{},
						{
							"Physical Name": "Brookshire Brothers, Inc",
							"Tax ID": "T124XP749",
							"Address Line 1": "5 Blocks from Street 2A",
							"Address Line 2": "2 Blocks from Street 2A",
							City: "Houston",
							State: "Texas",
							Zip: "700129",
							Fax: "F12P422"
						}
					)
				);
			}
		}
	}, [groupInformation, locationInformation]);
	// console.log("ami", groupInformation);
	return (
		<div className="group-information">
			<div className="logo">
				{groupInformation.group_number === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS ? (
					<img src={BBILogo} alt="logo" />
				) : groupInformation.group_number === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? (
					<img src={IntercityDarkLogo} style={{ width: "100%" }} alt="ici-logo" />
				) : null}
			</div>
			<div className="group-name">{groupInformation && groupInformation.name}</div>
			<div className="divider-container">
				<div className="dark-divider" />
				<div className="green-divider" />
			</div>
			<Grid container className="details" spacing={2}>
				{groupInformation && groupBasicDetails && coverageDetails ? (
					<>
						<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
							<Suspense fallback={<div />}>
								<GroupProfile details={groupBasicDetails} header={"Basic Details"} />
							</Suspense>
						</Grid>
						<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
							<Suspense fallback={<div />}>
								<GroupProfile details={coverageDetails} header={"Coverage"} />
							</Suspense>
						</Grid>
					</>
				) : (
					<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
						<Suspense fallback={<div />}>
							{locationBasicDetails ? (
								<GroupProfile details={locationBasicDetails} header={"Basic Details"} />
							) : null}
						</Suspense>
					</Grid>
				)}
			</Grid>
			<div className="special-details">
				<div className="special-detail">
					<GroupWorkIcon />
					<div className="field">
						<span className="label">Master Number:</span>
						<span className="value">&nbsp; 202-210</span>
					</div>
				</div>
				<div className="special-detail">
					<GroupIcon />
					<div className="field">
						<span className="label">Group Number:</span>
						<span className="value">&nbsp; &nbsp;{groupInformation && groupInformation.group_number}</span>
					</div>
				</div>
				<div className="special-detail">
					<EmailIcon />
					<div className="field">
						<span className="label">Email:</span>
						<span className="value">&nbsp; {groupInformation && groupInformation.email}</span>
					</div>
				</div>
				<div className="special-detail">
					<PhoneIcon />
					<div className="field">
						<span className="label">Phone:</span>
						<span className="value">&nbsp; {groupInformation && groupInformation.phone}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GroupInformation;
